export const MANUAL_ANOMALIES_CONTEXT_COLUMN_FIELDS: string[] = [
  'stageId',
  'wellboreTypeId',
  'trajectoryTypeId',
  'sectionTypeId',
  'holeType',
  'stratUnitTypeId',
  'reservoirId',
  'runTypeId',
  'operationId',
] as const;
